import { FC } from 'react'
import styled from 'styled-components'
// import colors from '../components/colors'
// import FilterDisplay from './FilterDisplay'
// import { device } from '../device'
import { colors } from '../components'
import { ChangeFilterPayload } from '../state/filter/filterSlice'
import { RootState } from '../state/store'
import DayButtons from './DayButtons'
import SearchField from './SearchField'

// const SelectionContainer = styled.div`
//   padding: 1rem 1rem;
//   @media ${device.mobileM} {
//     padding: 1rem 2rem;
//   }
//   background-color: ${colors.filtersBackground};
// `

const StickyContainer = styled.div<{
  isSticky?: boolean
  isScrollingUp?: boolean
  onlyDayButtons?: boolean
}>`
  position: ${(props) => (props.isSticky ? 'sticky' : 'relative')};
  top: ${(props) =>
    props.isScrollingUp || props.onlyDayButtons ? '-1px' : '-57px'};
  z-index: ${colors.zIndex.stickyStuff};
  transition: top 0.2s ease-in-out;
`

const SearchContainer = styled.div`
  padding: 0;
`

type Props = {
  alwaysDayButtons: boolean
  hideDayButtons: boolean
  onlyDayButtons: boolean
  filters: RootState['filter']
  day: string
  changeFilter: (payload: ChangeFilterPayload) => void
  scrollToTop: () => void
  isScrollingUp?: boolean
}

const Selection: FC<Props> = ({
  alwaysDayButtons,
  hideDayButtons,
  onlyDayButtons,
  filters,
  day,
  changeFilter,
  scrollToTop,
  isScrollingUp = false,
}) => (
  <>
    <StickyContainer
      isSticky
      isScrollingUp={isScrollingUp}
      onlyDayButtons={onlyDayButtons}
    >
      {!onlyDayButtons && (
        <SearchContainer>
          <SearchField changeFilter={changeFilter} />
        </SearchContainer>
      )}
      {(!filters.search || alwaysDayButtons) && !hideDayButtons && (
        <DayButtons
          day={day}
          // eslint-disable-next-line @typescript-eslint/no-shadow
          onDayClick={(day) => {
            changeFilter({ filterId: 'days', value: day })
            scrollToTop()
          }}
        />
      )}
    </StickyContainer>
  </>
)

export default Selection
